import React, { useState, useRef, useEffect } from 'react';

function ReadMoreLess({ ckeditorData, maxLines = 4 }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null); // Reference to the text container

  useEffect(() => {
    // Check if the content height exceeds the clamped height
    const element = textRef.current;
    const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
    const maxHeight = lineHeight * maxLines; // Calculate the max height allowed for the clamped content

    if (element.scrollHeight > maxHeight) {
      setIsOverflowing(true); // Show "Read More" if content is taller than 4 lines
    }
  }, [ckeditorData, maxLines]);

  const toggleReadMore = () => {
    setIsExpanded((prevState) => !prevState);
  };

  return (
    <div>
      <div ref={textRef} className={isExpanded ? 'expanded' : 'clamped'} dangerouslySetInnerHTML={{ __html: ckeditorData || '' }} />
      {isOverflowing && (
        <button type="button" id="readMoreLess" className="btn btn-toggle-html" onClick={toggleReadMore}>
          {isExpanded ? 'View Less' : 'View More'}
        </button>
      )}
    </div>
  );
}

export default ReadMoreLess;
